import {MAX_PLAYBACK_SPEED_MULTIPLIER} from './playbackSpeed';

// Что крутится на витрине главного меню (десктоп, см. MenuDemoGame).
//
// Режимов два, и переключение между ними — ровно одна строка ниже:
//  - REPLAY   — запись случайного реального матча с сервера (по умолчанию):
//               живые никнеймы, настоящие решения игроков;
//  - BOT_DEMO — живая партия ботов прямо в браузере (прежнее поведение):
//               не требует сервера и работает даже на пустой базе.
//
// Обе ветки живые: на режим бот-демо витрина сама откатывается, если реплей
// получить не удалось (сеть, пустая база записей), — так что код второго
// режима не гниет без присмотра
export const MENU_SHOWCASE_MODES = {
  REPLAY: 'replay',
  BOT_DEMO: 'bot_demo',
};

export const MENU_SHOWCASE_MODE = MENU_SHOWCASE_MODES.REPLAY;

// Шаг воспроизведения записи на витрине: одно записанное действие раз в 2
// секунды. Медленнее живой партии ботов намеренно — витрину смотрят краем
// глаза, и уследить за происходящим важнее, чем досмотреть матч до конца
export const MENU_REPLAY_ACTION_INTERVAL_MS = 2000;

// Множитель скорости витрины: с каким значением она стартует и до какого его
// можно поднять ползунком. Пределы у витрины свои, отдельно от скорости ботов
// в локальной партии (та настраивается на HotSeatPlayersInitPage): здесь
// крутится запись уже сыгранного матча, и разгонять ее можно смелее —
// смотреть партию целиком в реальном темпе никто не станет
export const MENU_SHOWCASE_SPEED_DEFAULT = 5;
export const MENU_SHOWCASE_SPEED_MAX = MAX_PLAYBACK_SPEED_MULTIPLIER;
